export default __webpack_public_path__ + "static/media/hamburger.a5025c95.svg";